import React, { useEffect } from "react";
import { BrowserRouter, Route } from "react-router-dom";

import AppLayout from "modules/1_layout/web/AppLayout";
import AuthGate from "modules/auth/AuthGate";
import qs from "query-string";

import { toggleFullscreen } from "modules/3_reducers/web/ThemeOptions";
import { useDispatch, useSelector } from "react-redux";

const Router = (props) => {
  const query = qs.parse(location?.search);
  const { fullscreen } = query;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(toggleFullscreen(fullscreen == "true"));
  }, [fullscreen]);

  const fullscreenEnabled = useSelector((state) => state?.ThemeOptions.fullscreenEnabled);

  return (
    <BrowserRouter>
      <AuthGate>
        <Route
          path="/"
          name="Home"
          render={(routeProps) => (
            <AppLayout fullscreenEnabled={fullscreenEnabled} forceFullscreen={fullscreen == "true"} {...routeProps} />
          )}
        />
      </AuthGate>
    </BrowserRouter>
  );
};

export default Router;
